module.exports = __webpack_public_path__ + "static/media/kobe.e3318e41.png";